import CardContent from '@material-ui/core/CardContent';
import ClearIcon from '@material-ui/icons/Clear';
import Grid from '@material-ui/core/Grid';
import LoadingBar from '../../../common/components/loading-bar';
import ProgressStatement from '../../../common/components/charts/progress-statement';
import PropTypes from 'prop-types';
import React from 'react';
import Remove from '@material-ui/icons/Remove';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import TripOrigin from '@material-ui/icons/TripOrigin';
import Warning from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    icon: {
        color: theme.palette.grey[400],
        height: '0.7em',
        width: '0.7em'
    }
} );

export const DomainCoverageProgressStatement = ( {
    classes, isLoaded, totalReject, totalQuarantine, totalMonitor, totalInvalid, totalNone
} ) => {
    return (
        <React.Fragment>
            { isLoaded ? (
                <React.Fragment>
                    <Grid container direction="row" justify="flex-start">
                        <Grid item xs={12} sm={3}>
                            <ProgressStatement
                                stat={totalReject}
                                icon={<RemoveCircle classes={{ root: classes.icon }} /> }
                                title="Reject Policy (p=reject)"
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <ProgressStatement
                                stat={totalQuarantine}
                                icon={<Warning classes={{ root: classes.icon }} /> }
                                title="Quarantine Policy (p=quarantine)"
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <ProgressStatement
                                stat={totalMonitor}
                                icon={<TripOrigin classes={{ root: classes.icon }}/> }
                                title="Monitor Policy (p=none)"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" justify="flex-start">
                        <Grid item xs={6} sm={3}>
                            <ProgressStatement
                                stat={totalInvalid}
                                icon={<ClearIcon classes={{ root: classes.icon }}/> }
                                title="Invalid"
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <ProgressStatement
                                stat={totalNone}
                                icon={<Remove classes={{ root: classes.icon }}/> }
                                title="No Record"
                            />
                        </Grid>
                    </Grid>
                </React.Fragment>
            ) : (
                <CardContent>
                    <LoadingBar />
                </CardContent>
            )}
        </React.Fragment>
    );
};

DomainCoverageProgressStatement.propTypes = {
    classes: PropTypes.object,
    isLoaded: PropTypes.bool,
    totalInvalid: PropTypes.number,
    totalMonitor: PropTypes.number,
    totalNone: PropTypes.number,
    totalQuarantine: PropTypes.number,
    totalReject: PropTypes.number,
};

export default withStyles( styles )( DomainCoverageProgressStatement );
